function endsWith(string, search) {
  if (search.length === 0) {
    return true;
  }
  if (search.length === 1) {
    return string[string.length - 1] === search;
  }
  return string.substring(string.length - search.length) === search;
}
export {
  endsWith
};
//# sourceMappingURL=endsWith.js.map
